/* dn-adoffer.js - Google Ads free-delivery test (code FREEDEL15, 22 Oct - 6 Nov 2026).
   A visitor who lands from a Google ad (gclid / gbraid / wbraid, or utm_source=google + utm_medium=cpc)
   is remembered for 7 days: the code is put on their cart (Cart AJAX API "discount", plus the
   /discount/ link as a fallback) and a slim banner tells them delivery is free over £15.
   Everyone else sees nothing. The whole thing switches itself off after END. */
(function () {
  var CODE = 'FREEDEL15', KEY = 'dnAdOffer', END = Date.UTC(2026, 10, 6, 23, 59);
  if (Date.now() > END) return;
  var q = new URLSearchParams(location.search);
  var fromAd = q.has('gclid') || q.has('gbraid') || q.has('wbraid') ||
    (q.getAll('utm_source').indexOf('google') > -1 && q.getAll('utm_medium').indexOf('cpc') > -1);  // Google's feed links repeat utm_* (product_sync first, cpc second)
  var on = fromAd;
  try {
    if (fromAd) localStorage.setItem(KEY, String(Date.now()));
    var t = +localStorage.getItem(KEY);
    on = on || (t > 0 && Date.now() - t < 7 * 864e5);
  } catch (e) {}
  if (!on) return;

  function apply() {
    fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      // dn_ad tells the basket's delivery note (cart-summary DNSHIPNOTE) to quote the £15 threshold
      body: JSON.stringify({ discount: CODE, attributes: { dn_ad: '1' } })
    }).catch(function () {});
  }
  fetch('/discount/' + CODE, { credentials: 'same-origin' }).catch(function () {}).then(apply);
  // the cart may not exist yet on the landing page, so re-apply after anything goes into it
  ['cart:update', 'cart:item-added', 'variant:add'].forEach(function (ev) { document.addEventListener(ev, apply); });
  document.addEventListener('submit', function (e) {
    var a = (e.target && e.target.getAttribute && e.target.getAttribute('action')) || '';
    if (a.indexOf('/cart') === 0) setTimeout(apply, 800);
  }, true);

  function banner() {
    if (document.getElementById('dn-adoffer')) return;
    var b = document.createElement('div');
    b.id = 'dn-adoffer';
    b.setAttribute('role', 'note');
    b.style.cssText = 'background:#2B2622;color:#F5EFE6;font:500 14px/1.4 Georgia,serif;text-align:center;padding:9px 40px 9px 16px;position:relative;z-index:5';
    b.innerHTML = '<strong style="color:#D9B97A">Free UK delivery</strong> on orders over £15 &middot; already applied at checkout' +
      '<button aria-label="Close" style="position:absolute;right:10px;top:50%;transform:translateY(-50%);background:none;border:0;color:#F5EFE6;font-size:18px;cursor:pointer;line-height:1">&times;</button>';
    b.querySelector('button').onclick = function () { b.remove(); };
    document.body.insertBefore(b, document.body.firstChild);
    // the store-wide announcement says 'Free UK delivery over £40'; for these visitors it would contradict the offer
    [].forEach.call(document.querySelectorAll('aside.announcement-bar'), function (a) {
      if (/£\s?40/.test(a.textContent)) a.style.display = 'none';
    });
  }
  if (document.body) banner(); else document.addEventListener('DOMContentLoaded', banner);
})();
